/**
 * ⭐ THE LOGO: THE COMPANY'S, OR OURS.
 *
 * ⛔ RENDERED AS AN <img>, NEVER INJECTED AS MARKUP. The value is an https URL or
 * a base64 raster that the server has already proved is a PNG/JPEG/WEBP/GIF — and
 * SVG is refused precisely so that this element can never become a script host
 * (§1Y.2).
 *
 * ⚠️ AND IT FALLS BACK ON ERROR. A URL that 404s or a data URI that will not
 * decode leaves an empty box in the corner of every screen; the built-in mark is
 * better than a broken image icon.
 *
 * ---- ⛔⛔ WHY THIS IS ITS OWN FILE (2026-09-07) -------------------------
 *
 * !!!! IT LIVED INSIDE App.tsx AS A PRIVATE FUNCTION, AND CarrierAppShell COULD
 *      NOT IMPORT IT. So the carrier portal drew `<SymbiaLogoMark>` directly --
 *      the built-in mark, hardcoded, ignoring branding.logo entirely.
 *
 * ** THE BRANDING SCREEN SHOWED A LOGO SET ON THE CARRIER APP, PREVIEWED IT ON
 *    THE BAR, SAVED IT, AND THE CARRIER PORTAL KEPT DRAWING OURS. Nothing
 *    errored. It is the same category error the header LITERALS were on
 *    2026-09-07 -- "Symbia Dock" / "Carrier Portal" typed into the shell while
 *    the settings screen believed it owned them -- caught then for the text and
 *    missed for the picture.
 *
 * ⛔ EVERY SHELL THAT DRAWS A HEADER IMPORTS THIS. A second copy is how one
 * surface honours a customer's logo and another does not.
 */
import { useState } from 'react';
import { SymbiaLogoMark } from '@/components/SymbiaLogoMark';

export function BrandLogo({ logo, alt }: { logo: string | null; alt: string }) {
    const [broken, setBroken] = useState(false);
    if (!logo || broken) {
        return (
            <div className="app-logo">
                <SymbiaLogoMark width={20} height={20} monochrome="white" />
            </div>
        );
    }
    return (
        <img
            src={logo}
            alt={alt}
            onError={() => setBroken(true)}
            className="app-logo-img"
        />
    );
}
